const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const PIXEL_ID = 'C3AVBM0EDD96P0IA41D0'

const tiktokPixelScript = `
!(function(e, t, n) {
  e.TiktokAnalyticsObject = n;
  var o = (e[n] = e[n] || []);
  (o.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ]),
    (o.setAndDefer = function(e, t) {
      e[t] = function() {e.push([t].concat(Array.prototype.slice.call(arguments, 0)));};
    });
  for (var a = 0; a < o.methods.length; a++) o.setAndDefer(o, o.methods[a]);
  (o.instance = function(e) {
    for (var t = o._i[e] || [], n = 0; n < o.methods.length; n++)
      o.setAndDefer(t, o.methods[n]);
    return t;
  }),
    (o.load = function(e, t) {
      var a = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      (o._i = o._i || {}),
        (o._i[e] = []),
        (o._i[e]._u = a),
        (o._t = o._t || {}),
        (o._t[e] = +new Date()),
        (o._o = o._o || {}),
        (o._o[e] = t || {});
      var i = document.createElement('script');
      (i.type = 'text/javascript'),
        (i.async = !0),
        (i.src = a + '?sdkid=' + e + '&lib=' + n);
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(i, s);
    }),

    o.load('${PIXEL_ID}'),
    o.page();

})(window, document, 'ttq');
`

exports.onClientEntry = () => {
  const tiktokPixelInit = () => {
    const script = document.createElement('script')
    script.id = 'gatsby-plugin-tiktok-pixel'
    const inlineScript = document.createTextNode(tiktokPixelScript)
    script.appendChild(inlineScript)
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  window.removeEventListener(cookieAcceptEventName, tiktokPixelInit)
  window.addEventListener(cookieAcceptEventName, tiktokPixelInit, {
    once: true,
  })

  if (hasAcceptedCookies('analytics')) tiktokPixelInit()
}
